/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Attach Phi surfaces to STL (BETA!)</h4>

<p>Attach the selected phi surfaces onto reference STL files. Ηit this button, then follow these three steps in sequence:</p>

<ul>
    <li> <p>"1" attaches all vertices to the STL surface.</p></li>
    <li> <p>"2" deforms the edges onto follow the STL surface.</p></li>
    <li> <p>"3" (optionally) for further smoothening.</p></li>
</ul>

<p>At any time you can select a part of the surface, move it, then repeat for slightly different results.</p>`;

export default function AttachToSTLTooltip() {
    return h('div', { innerHTML: body });
}
